exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mypage-manager{min-height:calc(100vh - 191px);text-align:center;padding-top:30px}.mypage-title{font-family:NanumBarunGothicOTF;font-size:32px;font-weight:400;margin-bottom:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71db7b90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/MypageManager.vue
// module id = 297
// module chunks = 0